<template>
  <div class="big-screen-container">
    <!-- 顶部数据总览 -->
    <div class="top-overview">
      <div class="overview-card">
        <div class="overview-icon" style="background-color: #409eff">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="overview-content">
          <div class="overview-title">虾塘总数</div>
          <div class="overview-value">
            {{ overview.pondTotal.toLocaleString() }}
          </div>
          <div class="overview-trend">
            <span class="trend-up">+{{ overview.pondGrowth }}%</span> 较上月
          </div>
        </div>
      </div>

      <div class="overview-card">
        <div class="overview-icon" style="background-color: #67c23a">
          <i class="el-icon-cpu"></i>
        </div>
        <div class="overview-content">
          <div class="overview-title">设备总数</div>
          <div class="overview-value">
            {{ overview.deviceTotal.toLocaleString() }}
          </div>
          <div class="overview-trend">
            <span class="trend-up">+{{ overview.deviceGrowth }}%</span> 较上月
          </div>
        </div>
      </div>

      <div class="overview-card">
        <div class="overview-icon" style="background-color: #e6a23c">
          <i class="el-icon-link"></i>
        </div>
        <div class="overview-content">
          <div class="overview-title">在线设备</div>
          <div class="overview-value">
            {{ overview.onlineDevices.toLocaleString() }}
          </div>
          <div class="overview-rate">
            在线率: <span class="rate-high">{{ overview.onlineRate }}%</span>
          </div>
        </div>
      </div>

      <div class="overview-card">
        <div class="overview-icon" style="background-color: #f56c6c">
          <i class="el-icon-disconnect"></i>
        </div>
        <div class="overview-content">
          <div class="overview-title">离线设备</div>
          <div class="overview-value">
            {{ overview.offlineDevices.toLocaleString() }}
          </div>
          <div class="overview-rate">
            离线率: <span class="rate-high">{{ overview.offlineRate }}%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧统计图 -->
      <div class="left-chart">
        <div class="chart-header">
          <h3>各省份虾塘设备统计</h3>
          <div class="chart-actions">
            <el-radio-group
              v-model="leftChartType"
              size="small"
              @change="updateLeftChart"
            >
              <el-radio-button label="province">省份排名</el-radio-button>
              <el-radio-button label="city">城市详情</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div
          class="chart-container"
          ref="leftChart"
          style="width: 100%; height: calc(100% - 50px)"
        ></div>
      </div>

      <!-- 中间地图 -->
      <div class="map-container">
        <div class="map-header">
          <h3>虾塘分布地图</h3>
          <div class="map-actions">
            <el-button
              v-if="currentView !== 'china'"
              size="small"
              icon="el-icon-back"
              @click="goBack"
            >
              返回上一级
            </el-button>
          </div>
        </div>
        <!-- 使用iframe直接引入map.html -->
        <iframe
          class="map-content"
          src="/map.html"
          frameborder="0"
          style="width: 100%; height: 600px"
        ></iframe>
      </div>

      <!-- 右侧统计图 -->
      <div class="right-chart">
        <div class="chart-header">
          <h3>设备状态与增长趋势</h3>
          <div class="chart-actions">
            <el-select
              v-model="timeRange"
              placeholder="时间范围"
              size="small"
              style="width: 120px"
              @change="updateRightChart"
            >
              <el-option label="近7天" value="7"></el-option>
              <el-option label="近30天" value="30"></el-option>
              <el-option label="近90天" value="90"></el-option>
            </el-select>
          </div>
        </div>
        <div class="chart-container" style="height: 45%">
          <div ref="growthChart" style="width: 100%; height: 100%"></div>
        </div>
        <div class="chart-container" style="height: 45%; margin-top: 10px">
          <div ref="statusChart" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
// 导入api接口
import { shrimpPondPage, getAllCentralCoordinate } from "../api/pond";
import { listAllDevices, checkDevicesOnline } from "../api/device";
// 导入数据处理工具函数
import {
  processProvinceData,
  processCityData,
  getGuangdongCities,
} from "../utils/dataUtils";

export default {
  name: "BigScreenData",
  data() {
    return {
      // 顶部概览数据
      overview: {
        pondTotal: 0,
        deviceTotal: 0,
        onlineDevices: 0,
        offlineDevices: 0,
        pondGrowth: 0,
        deviceGrowth: 0,
        onlineRate: 0,
        offlineRate: 0,
      },

      // 左侧图表
      leftChartType: "province",
      selectedProvince: "",
      provinceOptions: [],
      leftChartInstance: null,

      // 右侧图表
      timeRange: "30",
      growthChartInstance: null,
      statusChartInstance: null,

      // 图表配置缓存
      leftChartOptionCache: null,
      rightChartOptionCache: null,

      // 数据
      provincesData: [],
      ponds: [],
      devices: [],
      onlineDeviceIds: [],
      pondCoordinates: [],
      guangdongCityData: [], // 广东省城市数据
      districtData: {}, // 区县数据，按城市名称存储

      // 当前视图状态
      currentView: "china",

      // 省份地图数据
      provinces: [
        "shanghai",
        "hebei",
        "shanxi",
        "neimenggu",
        "liaoning",
        "jilin",
        "heilongjiang",
        "jiangsu",
        "zhejiang",
        "anhui",
        "fujian",
        "jiangxi",
        "shandong",
        "henan",
        "hubei",
        "hunan",
        "guangdong",
        "guangxi",
        "hainan",
        "sichuan",
        "guizhou",
        "yunnan",
        "xizang",
        "shanxi1",
        "gansu",
        "qinghai",
        "ningxia",
        "xinjiang",
        "beijing",
        "tianjin",
        "chongqing",
        "xianggang",
        "aomen",
      ],
      provincesText: [
        "上海",
        "河北",
        "山西",
        "内蒙古",
        "辽宁",
        "吉林",
        "黑龙江",
        "江苏",
        "浙江",
        "安徽",
        "福建",
        "江西",
        "山东",
        "河南",
        "湖北",
        "湖南",
        "广东",
        "广西",
        "海南",
        "四川",
        "贵州",
        "云南",
        "西藏",
        "陕西",
        "甘肃",
        "青海",
        "宁夏",
        "新疆",
        "北京",
        "天津",
        "重庆",
        "香港",
        "澳门",
      ],
    };
  },
  created() {
    // 从api获取数据
    this.fetchData();
  },
  mounted() {
    // 组件挂载后初始化图表和地图类型变化处理函数
    this.$nextTick(() => {
      this.initCharts();
      this.initMapTypeChangeHandler();
    });
  },
  methods: {
    // 从api获取数据
    async fetchData() {
      try {
        // 获取虾塘数据
        const pondResponse = await shrimpPondPage({ pageSize: 1000 });
        this.ponds = pondResponse.data?.rows || pondResponse.data || [];
        this.overview.pondTotal =
          parseInt(pondResponse.data?.total) || this.ponds.length || 0;

        // 获取设备数据
        const deviceResponse = await listAllDevices();
        this.devices = deviceResponse.data || [];
        this.overview.deviceTotal = this.devices.length;

        // 根据设备状态字段直接统计在线/离线设备
        if (this.devices.length > 0) {
          // 统计在线设备（status === 'online'）
          const onlineDevices = this.devices.filter((device) => {
            const status = device.status?.toLowerCase();
            return status === "online" || status === "1" || status === "true";
          });

          this.overview.onlineDevices = onlineDevices.length;
          this.overview.offlineDevices =
            this.devices.length - onlineDevices.length;

          // 计算在线率/离线率
          if (this.devices.length > 0) {
            this.overview.onlineRate = (
              (this.overview.onlineDevices / this.devices.length) *
              100
            ).toFixed(1);
            this.overview.offlineRate = (
              (this.overview.offlineDevices / this.devices.length) *
              100
            ).toFixed(1);
          } else {
            this.overview.onlineRate = 0;
            this.overview.offlineRate = 0;
          }

          // 仍然调用在线检测API获取最新状态（可选）
          try {
            const deviceIds = this.devices
              .map((device) => device.id)
              .filter((id) => id);
            if (deviceIds.length > 0) {
              await checkDevicesOnline(deviceIds);
              // 如果API返回最新的在线状态，可以更新数据
              // 这里可以根据实际API返回结构进行调整
            }
          } catch (onlineError) {
            // 不影响主要功能，继续使用设备状态字段
          }
        } else {
          // 如果没有设备，设置默认值
          this.overview.onlineDevices = 0;
          this.overview.offlineDevices = 0;
          this.overview.onlineRate = 0;
          this.overview.offlineRate = 0;
        }

        // 获取虾塘中心点经纬度
        try {
          const coordinatesResponse = await getAllCentralCoordinate();
          this.pondCoordinates =
            coordinatesResponse.data || coordinatesResponse || [];
        } catch (error) {
          this.pondCoordinates = [];
        }

        // 计算增长率（这里需要从API获取历史数据，暂时使用模拟数据）
        // 在实际项目中，你应该有一个专门的API来获取增长数据
        this.overview.pondGrowth = 12.5;
        this.overview.deviceGrowth = 8.3;

        // 处理省份数据
        await this.processProvinceData();

        // 数据获取完成后，初始化图表并更新地图数据
        this.initCharts();
        this.updateMapData();
      } catch (error) {
        // 即使API调用失败，也显示默认数据
        await this.processProvinceData();
        this.initCharts();
      }
    },

    // 处理省份数据 - 基于实际数据
    async processProvinceData() {
      // 使用工具函数处理省份数据
      this.provincesData = processProvinceData(this.ponds, this.devices);

      // 处理广东省城市数据
      this.guangdongCityData = processCityData(
        this.ponds,
        this.devices,
        "广东"
      );

      // 处理区县数据 - 按城市存储，与地图数据生成方法一致
      this.districtData = {};

      // 获取广东省所有城市列表
      const guangdongCitiesList = getGuangdongCities();

      // 为广东省每个城市生成区县数据，与地图数据生成方法一致
      for (const city of guangdongCitiesList) {
        const cityName = city.name;
        const shortCityName = cityName.replace(/市$/, "");

        // 查找该城市的城市数据
        const cityData = this.guangdongCityData.find(
          (item) => item.name === shortCityName
        ) || {
          pondCount: 0,
          deviceCount: 0,
          onlineDevices: 0,
          offlineDevices: 0,
        };

        // 模拟区县名称列表（与地图使用相同的名称）
        const mockDistrictNamesMap = {
          广州市: [
            "天河区",
            "越秀区",
            "海珠区",
            "荔湾区",
            "白云区",
            "黄埔区",
            "番禺区",
            "花都区",
            "南沙区",
            "从化区",
            "增城区",
          ],
          深圳市: [
            "罗湖区",
            "福田区",
            "南山区",
            "宝安区",
            "龙岗区",
            "盐田区",
            "龙华区",
            "坪山区",
            "光明区",
          ],
          韶关市: [
            "武江区",
            "浈江区",
            "曲江区",
            "乐昌市",
            "南雄市",
            "始兴县",
            "仁化县",
            "翁源县",
            "新丰县",
            "乳源瑶族自治县",
          ],
          珠海市: ["香洲区", "斗门区", "金湾区"],
          汕头市: [
            "龙湖区",
            "金平区",
            "濠江区",
            "潮阳区",
            "潮南区",
            "澄海区",
            "南澳县",
          ],
          佛山市: ["禅城区", "南海区", "顺德区", "三水区", "高明区"],
          江门市: [
            "蓬江区",
            "江海区",
            "新会区",
            "台山市",
            "开平市",
            "鹤山市",
            "恩平市",
          ],
          湛江市: [
            "赤坎区",
            "霞山区",
            "坡头区",
            "麻章区",
            "廉江市",
            "雷州市",
            "吴川市",
            "遂溪县",
            "徐闻县",
          ],
          茂名市: ["茂南区", "电白区", "高州市", "化州市", "信宜市"],
          肇庆市: [
            "端州区",
            "鼎湖区",
            "高要区",
            "四会市",
            "广宁县",
            "怀集县",
            "封开县",
            "德庆县",
          ],
          惠州市: ["惠城区", "惠阳区", "博罗县", "惠东县", "龙门县"],
          梅州市: [
            "梅江区",
            "梅县区",
            "兴宁市",
            "大埔县",
            "丰顺县",
            "五华县",
            "平远县",
            "蕉岭县",
          ],
          汕尾市: ["城区", "海丰县", "陆河县", "陆丰市"],
          河源市: ["源城区", "紫金县", "龙川县", "连平县", "和平县", "东源县"],
          阳江市: ["江城区", "阳东区", "阳西县", "阳春市"],
          清远市: [
            "清城区",
            "清新区",
            "英德市",
            "连州市",
            "佛冈县",
            "阳山县",
            "连山壮族瑶族自治县",
            "连南瑶族自治县",
          ],
          东莞市: [
            "东城区",
            "南城区",
            "万江区",
            "莞城区",
            "石碣镇",
            "石龙镇",
            "茶山镇",
            "石排镇",
            "企石镇",
            "横沥镇",
          ],
          中山市: [
            "石岐区",
            "东区",
            "南区",
            "西区",
            "小榄镇",
            "古镇镇",
            "横栏镇",
            "东升镇",
            "港口镇",
            "沙溪镇",
          ],
          潮州市: ["湘桥区", "潮安区", "饶平县"],
          揭阳市: ["榕城区", "揭东区", "普宁市", "揭西县", "惠来县"],
          云浮市: ["云城区", "云安区", "罗定市", "新兴县", "郁南县"],
        };

        // 获取该城市的区县名称列表
        const districtNames = mockDistrictNamesMap[cityName] || [
          "城区1",
          "城区2",
          "城区3",
          "城区4",
          "城区5",
        ];
        const totalDistricts = districtNames.length;

        // 按地图的方法生成区县数据
        const cityDistrictData = [];
        if (cityData.pondCount > 0 || cityData.deviceCount > 0) {
          // 计算每个区县应分配的数据
          const pondsPerDistrict = Math.floor(
            cityData.pondCount / totalDistricts
          );
          const devicesPerDistrict = Math.floor(
            cityData.deviceCount / totalDistricts
          );
          const onlinePerDistrict = Math.floor(
            cityData.onlineDevices / totalDistricts
          );
          const offlinePerDistrict = Math.floor(
            cityData.offlineDevices / totalDistricts
          );

          // 剩余数据，将分配给最后一个区县
          const remainingPonds = cityData.pondCount % totalDistricts;
          const remainingDevices = cityData.deviceCount % totalDistricts;
          const remainingOnline = cityData.onlineDevices % totalDistricts;
          const remainingOffline = cityData.offlineDevices % totalDistricts;

          // 为每个区县分配数据
          for (let i = 0; i < totalDistricts; i++) {
            const districtName = districtNames[i];
            let pondCount = pondsPerDistrict;
            let deviceCount = devicesPerDistrict;
            let onlineDevices = onlinePerDistrict;
            let offlineDevices = offlinePerDistrict;

            // 最后一个区县分配剩余数据
            if (i === totalDistricts - 1) {
              pondCount += remainingPonds;
              deviceCount += remainingDevices;
              onlineDevices += remainingOnline;
              offlineDevices += remainingOffline;
            }

            cityDistrictData.push({
              name: districtName,
              value: pondCount,
              pondCount: pondCount,
              deviceCount: deviceCount,
              onlineDevices: onlineDevices,
              offlineDevices: offlineDevices,
            });
          }
        } else {
          // 如果城市没有数据，所有区县数据为0
          for (let i = 0; i < totalDistricts; i++) {
            cityDistrictData.push({
              name: districtNames[i],
              value: 0,
              pondCount: 0,
              deviceCount: 0,
              onlineDevices: 0,
              offlineDevices: 0,
            });
          }
        }

        this.districtData[shortCityName] = cityDistrictData;
      }
    },

    // 初始化图表
    initCharts() {
      this.initProvinceOptions();
      this.initLeftChart();
      this.initRightCharts();

      // 模拟实时数据更新（每30秒更新一次）
      setInterval(() => {
        this.updateRealTimeData();
      }, 30000);
    },

    // 初始化省份选项
    initProvinceOptions() {
      // 只显示有数据的省份
      const availableProvinces = this.provincesData.map((item) => item.name);
      this.provinceOptions = this.provincesText
        .filter((text) => availableProvinces.includes(text))
        .map((text, index) => ({
          label: text,
          value: this.provinces[index],
        }));

      // 默认选择第一个省份
      if (this.provinceOptions.length > 0) {
        this.selectedProvince = this.provinceOptions[0].value;
      }
    },

    // 初始化左侧图表
    initLeftChart() {
      if (!this.$refs.leftChart) return;
      // 销毁旧实例，避免重复初始化
      if (this.leftChartInstance) {
        this.leftChartInstance.dispose();
      }
      this.leftChartInstance = echarts.init(this.$refs.leftChart);
      this.updateLeftChart();
    },

    // 更新左侧图表
    updateLeftChart() {
      if (!this.leftChartInstance) return;

      let option;

      // 生成缓存键
      const cacheKey =
        this.leftChartType +
        "_" +
        this.currentView +
        "_" +
        JSON.stringify(this.provincesData) +
        "_" +
        JSON.stringify(this.guangdongCityData) +
        "_" +
        JSON.stringify(this.districtData);

      // 如果缓存存在且键匹配，直接使用缓存配置
      if (
        this.leftChartOptionCache &&
        this.leftChartOptionCache.key === cacheKey
      ) {
        option = this.leftChartOptionCache.option;
      } else {
        // 重新计算图表配置
        if (this.leftChartType === "province") {
          // 只保留有数据的省份
          const provincesWithData = this.provincesData.filter(
            (item) => item.pondCount > 0 || item.deviceCount > 0
          );

          // 按照虾塘数量从高到低排序
          const sortedProvincesData = [...provincesWithData].sort(
            (a, b) => b.pondCount - a.pondCount
          );

          // 不设置固定宽度，让图表自适应容器
          // 移除固定宽度设置，让图表容器继承父容器宽度
          this.$refs.leftChart.style.width = "100%";

          const barWidth = 12; // 定义柱体宽度

          option = {
            title: {
              show: false,
            },
            tooltip: {
              trigger: "item",
              axisPointer: {
                type: "shadow",
              },
              formatter: (params) => {
                let result = `<div style="margin-bottom: 5px; font-weight: bold;">${params.name}</div>`;
                const value = params.value;
                const seriesName = params.seriesName;
                let color = params.color;

                if (seriesName === "虾塘数量") {
                  result += `<div style="margin: 3px 0;"><span style="display: inline-block; width: 8px; height: 8px; background: ${color}; border-radius: 50%; margin-right: 5px;"></span>虾塘数量: <span style="font-weight: bold;">${value}</span></div>`;
                } else if (seriesName === "设备数量") {
                  result += `<div style="margin: 3px 0;"><span style="display: inline-block; width: 8px; height: 8px; background: ${color}; border-radius: 50%; margin-right: 5px;"></span>设备数量: <span style="font-weight: bold;">${value}</span></div>`;
                }
                return result;
              },
            },
            legend: {
              data: ["虾塘数量", "设备数量"],
              top: "0%",
              left: "center",
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              itemGap: 15, // 增加图例项之间的间距
            },
            grid: {
              left: "50px",
              right: "60px",
              bottom: "60px", // 增加底部边距，确保省份名称显示完整
              top: "15%", // 调整顶部边距，确保图表与图例有足够间隔
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: sortedProvincesData.map((item) => item.name),
              axisLabel: {
                rotate: 45,
                fontSize: 10,
                color: "#fff",
                interval: 0,
                margin: 10, // 增加标签与轴线间距
              },
              axisLine: {
                lineStyle: {
                  color: "#fff",
                },
              },
              axisTick: {
                alignWithLabel: true,
                length: 5, // 调整刻度线长度
              },
            },
            yAxis: [
              {
                type: "value",
                name: "数量",
                position: "left",
                axisLabel: {
                  color: "#fff",
                  fontSize: 9,
                  margin: 8, // 增加标签与轴线间距
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#fff",
                  },
                },
                splitLine: {
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.1)",
                  },
                },
                min: 0,
                // 动态计算最大值，适应两个系列的数据
                max: Math.max(
                  Math.max(
                    ...sortedProvincesData.map((item) => item.pondCount)
                  ) + 2,
                  Math.max(
                    ...sortedProvincesData.map((item) => item.deviceCount)
                  ) + 2
                ),
                // 根据最大值动态调整间隔
                interval: 1,
              },
            ],
            series: [
              {
                name: "虾塘数量",
                type: "bar",
                barWidth: barWidth,
                barGap: "30%", // 调整柱体间间隙，让两个系列正确并列对齐
                barCategoryGap: "30%", // 设置合适的柱体类别间间隙
                data: sortedProvincesData.map((item) => item.pondCount),
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#83bff6" },
                    { offset: 0.5, color: "#188df0" },
                    { offset: 1, color: "#188df0" },
                  ]),
                },
                emphasis: {
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#2378f7" },
                      { offset: 0.7, color: "#2378f7" },
                      { offset: 1, color: "#83bff6" },
                    ]),
                  },
                },
              },
              {
                name: "设备数量",
                type: "bar",
                barWidth: barWidth,
                barGap: "30%", // 调整柱体间间隙，让两个系列正确并列对齐
                barCategoryGap: "30%", // 设置合适的柱体类别间间隙
                // 移除yAxisIndex，让两个系列使用同一个Y轴，实现柱体高度对齐
                data: sortedProvincesData.map((item) => item.deviceCount),
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#fbc2eb" },
                    { offset: 0.5, color: "#f56c6c" },
                    { offset: 1, color: "#f56c6c" },
                  ]),
                },
                emphasis: {
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#f56c6c" },
                      { offset: 0.7, color: "#f56c6c" },
                      { offset: 1, color: "#fbc2eb" },
                    ]),
                  },
                },
              },
            ],
          };
        } else {
          // 检查当前是否是区县地图
          let isDistrictMap = this.currentView.endsWith("_district");

          // 城市详情或区县详情（使用真实数据）
          let chartData = [];

          if (isDistrictMap) {
            // 区县地图，显示区县数据
            // 从当前地图类型中提取城市名称
            let cityName = this.currentView.split("_district")[0];

            // 移除城市名称中的"市"后缀，确保与districtData中的key匹配
            cityName = cityName.replace(/市$/, "");

            // 获取该城市的区县数据
            if (
              this.districtData[cityName] &&
              this.districtData[cityName].length > 0
            ) {
              chartData = this.districtData[cityName];
            }
          } else {
            // 城市地图，显示城市数据
            // 使用广东省城市真实数据
            if (
              this.currentView === "guangdong" &&
              this.guangdongCityData.length > 0
            ) {
              chartData = this.guangdongCityData;
            }
          }

          // 检查是否有数据
          const hasData = chartData.length > 0;

          if (!hasData) {
            // 如果没有数据，显示"暂无数据"并隐藏图表元素
            option = {
              title: {
                text: "暂无数据",
                left: "center",
                top: "center",
                textStyle: {
                  color: "#fff",
                  fontSize: 16,
                },
              },
              grid: {
                show: false,
              },
              xAxis: {
                show: false,
              },
              yAxis: {
                show: false,
              },
              series: [],
            };
          } else {
            // 按照虾塘数量排序
            chartData.sort((a, b) => b.pondCount - a.pondCount);

            // 不设置固定宽度，让图表自适应容器
            // 移除固定宽度设置，让图表容器继承父容器宽度
            this.$refs.leftChart.style.width = "100%";

            const barWidth = 12; // 定义柱体宽度

            option = {
              title: {
                show: false,
              },
              tooltip: {
                trigger: "item",
                axisPointer: {
                  type: "shadow",
                },
                formatter: (params) => {
                  let result = `<div style="margin-bottom: 5px; font-weight: bold;">${params.name}</div>`;
                  const value = params.value;
                  const seriesName = params.seriesName;
                  let color = params.color;

                  if (seriesName === "虾塘数量") {
                    result += `<div style="margin: 3px 0;"><span style="display: inline-block; width: 8px; height: 8px; background: ${color}; border-radius: 50%; margin-right: 5px;"></span>虾塘数量: <span style="font-weight: bold;">${value}</span></div>`;
                  } else if (seriesName === "设备数量") {
                    result += `<div style="margin: 3px 0;"><span style="display: inline-block; width: 8px; height: 8px; background: ${color}; border-radius: 50%; margin-right: 5px;"></span>设备数量: <span style="font-weight: bold;">${value}</span></div>`;
                  }
                  return result;
                },
              },
              legend: {
                data: ["虾塘数量", "设备数量"],
                top: "0%",
                left: "center",
                textStyle: {
                  color: "#fff",
                  fontSize: 10,
                },
                itemGap: 15, // 增加图例项之间的间距
              },
              grid: {
                left: "50px",
                right: "60px",
                bottom: "60px", // 增加底部边距，确保城市或区县名称显示完整
                top: "15%", // 调整顶部边距，确保图表与图例有足够间隔
                containLabel: true,
              },
              xAxis: {
                type: "category",
                data: chartData.map((item) => item.name),
                axisLabel: {
                  color: "#fff",
                  rotate: 45,
                  fontSize: 9,
                  interval: 0,
                  margin: 10, // 增加标签与轴线间距
                },
                axisLine: {
                  lineStyle: {
                    color: "#fff",
                  },
                },
                axisTick: {
                  alignWithLabel: true,
                  length: 5, // 调整刻度线长度
                },
              },
              yAxis: {
                type: "value",
                name: "数量",
                axisLabel: {
                  color: "#fff",
                  fontSize: 9,
                  margin: 8, // 增加标签与轴线间距
                },
                axisLine: {
                  lineStyle: {
                    color: "#fff",
                  },
                },
                min: 0,
                // 动态计算最大值，适应两个系列的数据
                max: Math.max(
                  Math.max(...chartData.map((item) => item.pondCount)) + 2,
                  Math.max(...chartData.map((item) => item.deviceCount)) + 2
                ),
                // 根据最大值动态调整间隔
                interval: 1,
              },
              series: [
                {
                  name: "虾塘数量",
                  type: "bar",
                  barWidth: barWidth,
                  barGap: "30%", // 调整柱体间间隙，让两个系列正确并列对齐
                  barCategoryGap: "30%", // 设置合适的柱体类别间间隙
                  data: chartData.map((item) => item.pondCount),
                  itemStyle: {
                    color: "#67C23A",
                  },
                },
                {
                  name: "设备数量",
                  type: "bar",
                  barWidth: barWidth,
                  barGap: "30%", // 调整柱体间间隙，让两个系列正确并列对齐
                  barCategoryGap: "30%", // 设置合适的柱体类别间间隙
                  data: chartData.map((item) => item.deviceCount),
                  itemStyle: {
                    color: "#409EFF",
                  },
                },
              ],
            };
          }
        }

        // 更新缓存
        this.leftChartOptionCache = {
          key: cacheKey,
          option: option,
        };
      }

      // 使用缓存配置渲染图表
      this.leftChartInstance.setOption(option, true);
    },

    // 初始化右侧图表
    initRightCharts() {
      if (!this.$refs.growthChart || !this.$refs.statusChart) return;
      // 销毁旧实例，避免重复初始化
      if (this.growthChartInstance) {
        this.growthChartInstance.dispose();
      }
      if (this.statusChartInstance) {
        this.statusChartInstance.dispose();
      }
      this.growthChartInstance = echarts.init(this.$refs.growthChart);
      this.statusChartInstance = echarts.init(this.$refs.statusChart);
      this.updateRightChart();
    },

    // 更新右侧图表
    updateRightChart() {
      if (!this.growthChartInstance || !this.statusChartInstance) return;

      // 生成缓存键
      const cacheKey =
        this.timeRange +
        "_" +
        this.overview.pondTotal +
        "_" +
        this.overview.deviceTotal +
        "_" +
        this.overview.onlineDevices +
        "_" +
        this.overview.offlineDevices;

      let growthOption, statusOption;

      // 如果缓存存在且键匹配，直接使用缓存配置
      if (
        this.rightChartOptionCache &&
        this.rightChartOptionCache.key === cacheKey
      ) {
        growthOption = this.rightChartOptionCache.growthOption;
        statusOption = this.rightChartOptionCache.statusOption;
      } else {
        // 重新计算图表配置
        // 增长趋势图 - 基于实际数据
        const days = parseInt(this.timeRange);
        const dates = [];
        const pondData = [];
        const deviceData = [];

        // 生成日期标签
        for (let i = days; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          dates.push(`${date.getMonth() + 1}/${date.getDate()}`);
        }

        // 使用当前数据作为趋势图的数据
        // 在实际项目中，这里应该从API获取历史数据
        const basePonds = this.overview.pondTotal;
        const baseDevices = this.overview.deviceTotal;

        // 使用相同的数据填充所有日期，确保数据真实
        for (let i = 0; i <= days; i++) {
          pondData.push(basePonds);
          deviceData.push(baseDevices);
        }

        growthOption = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
            formatter: (params) => {
              let result = `<div style="margin-bottom: 5px; font-weight: bold;">${params[0].name}</div>`;
              params.forEach((param) => {
                const value = param.value;
                const seriesName = param.seriesName;
                let color = param.color;
                result += `<div style="margin: 3px 0;"><span style="display: inline-block; width: 8px; height: 8px; background: ${color}; border-radius: 50%; margin-right: 5px;"></span>${seriesName}: <span style="font-weight: bold;">${value}</span></div>`;
              });
              return result;
            },
          },
          legend: {
            data: ["虾塘总数", "设备总数"],
            top: "5%",
            textStyle: {
              color: "#fff",
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            top: "20%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: dates,
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
          yAxis: {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
          series: [
            {
              name: "虾塘总数",
              type: "line",
              smooth: true,
              data: pondData,
              itemStyle: {
                color: "#67C23A",
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(103, 194, 58, 0.3)" },
                  { offset: 1, color: "rgba(103, 194, 58, 0.1)" },
                ]),
              },
            },
            {
              name: "设备总数",
              type: "line",
              smooth: true,
              data: deviceData,
              itemStyle: {
                color: "#409EFF",
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(64, 158, 255, 0.3)" },
                  { offset: 1, color: "rgba(64, 158, 255, 0.1)" },
                ]),
              },
            },
          ],
        };

        // 设备状态饼图 - 使用实际数据
        statusOption = {
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "left",
            top: "center",
            textStyle: {
              color: "#fff",
            },
          },
          series: [
            {
              name: "设备状态",
              type: "pie",
              radius: ["40%", "70%"],
              center: ["60%", "50%"],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: "#fff",
                borderWidth: 2,
              },
              label: {
                show: false,
                position: "center",
                formatter: "{b}\n{c} ({d}%)",
                color: "#fff",
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "16",
                  fontWeight: "bold",
                  color: "#fff",
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.overview.onlineDevices,
                  name: "在线设备",
                  itemStyle: { color: "#67C23A" },
                },
                {
                  value: this.overview.offlineDevices,
                  name: "离线设备",
                  itemStyle: { color: "#F56C6C" },
                },
                {
                  value: Math.max(
                    0,
                    this.overview.deviceTotal -
                      this.overview.onlineDevices -
                      this.overview.offlineDevices
                  ),
                  name: "待激活设备",
                  itemStyle: { color: "#E6A23C" },
                },
              ],
            },
          ],
        };

        // 更新缓存
        this.rightChartOptionCache = {
          key: cacheKey,
          growthOption: growthOption,
          statusOption: statusOption,
        };
      }

      // 使用缓存配置渲染图表
      this.growthChartInstance.setOption(growthOption);
      this.statusChartInstance.setOption(statusOption);
    },

    // 更新实时数据
    async updateRealTimeData() {
      // 重新调用API获取最新数据
      try {
        // 获取设备数据
        const deviceResponse = await listAllDevices({ page: 1, limit: 100 });
        const devices = deviceResponse.data || [];

        // 根据设备状态字段直接统计在线/离线设备
        if (devices.length > 0) {
          // 统计在线设备（status === 'online'）
          const onlineDevices = devices.filter((device) => {
            const status = device.status?.toLowerCase();
            return status === "online" || status === "1" || status === "true";
          });

          this.overview.onlineDevices = onlineDevices.length;
          this.overview.offlineDevices = devices.length - onlineDevices.length;

          // 计算在线率/离线率
          if (devices.length > 0) {
            this.overview.onlineRate = (
              (this.overview.onlineDevices / devices.length) *
              100
            ).toFixed(1);
            this.overview.offlineRate = (
              (this.overview.offlineDevices / devices.length) *
              100
            ).toFixed(1);
          }
        }

        // 更新状态饼图
        if (this.statusChartInstance) {
          const statusOption = this.statusChartInstance.getOption();
          statusOption.series[0].data[0].value = this.overview.onlineDevices;
          statusOption.series[0].data[1].value = this.overview.offlineDevices;
          statusOption.series[0].data[2].value = Math.max(
            0,
            this.overview.deviceTotal -
              this.overview.onlineDevices -
              this.overview.offlineDevices
          );
          this.statusChartInstance.setOption(statusOption);
        }

        // 更新地图数据
        this.updateMapData();
      } catch (error) {
        // 更新实时数据异常，忽略错误
      }
    },

    // 返回上一级地图
    goBack() {
      // 获取iframe元素
      const mapIframe = document.querySelector(".map-content");
      if (mapIframe && mapIframe.contentWindow) {
        try {
          // 调用iframe中的返回上一级地图方法
          mapIframe.contentWindow.goBack();
        } catch (error) {
          console.error("Error calling goBack:", error);
        }
      }
    },

    // 返回全国地图（保持兼容）
    backToChina() {
      this.currentView = "china";
      // 获取iframe元素
      const mapIframe = document.querySelector(".map-content");
      if (mapIframe && mapIframe.contentWindow) {
        try {
          // 调用iframe中的返回全国地图方法
          mapIframe.contentWindow.backToChinaMap();
        } catch (error) {
          console.error("Error calling backToChinaMap:", error);
        }
      }
    },

    // 更新地图数据
    updateMapData() {
      // 获取iframe元素
      const mapIframe = document.querySelector(".map-content");
      if (mapIframe && mapIframe.contentWindow) {
        try {
          // 调用iframe中的函数传递数据
          mapIframe.contentWindow.receiveMapData({
            provinces: this.provincesData,
            overview: this.overview,
            cityData: {
              guangdong: this.guangdongCityData, // 广东省城市数据
            },
          });
        } catch (error) {
          console.error("Error updating map data:", error);
        }
      }
    },

    // 初始化全局地图类型变化处理函数
    initMapTypeChangeHandler() {
      // 将处理函数挂载到window对象上，以便iframe调用
      window.handleMapTypeChange = (mapType) => {
        console.log("地图类型变化通知:", mapType);
        // 更新当前视图状态
        if (mapType === "china") {
          this.currentView = "china";
          // 切换回全国地图时，左侧图表显示省份排名
          this.leftChartType = "province";
          // 更新图表
          this.updateLeftChart();
        } else {
          // 非中国地图类型，显示返回按钮
          this.currentView = mapType;
          // 切换到省份地图或区县地图时，左侧图表显示城市详情或区县详情
          this.leftChartType = "city";
          // 更新图表
          this.updateLeftChart();
        }
      };
    },
  },
  beforeUnmount() {
    if (this.leftChartInstance) {
      this.leftChartInstance.dispose();
    }
    if (this.growthChartInstance) {
      this.growthChartInstance.dispose();
    }
    if (this.statusChartInstance) {
      this.statusChartInstance.dispose();
    }
  },
};
</script>

<style scoped>
page {
  margin: 0;
  padding: 0;
}

.big-screen-container {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #1a2a6c, #2a3c7f, #3a4e92);
  color: #fff;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

/* 顶部概览样式 */
.top-overview {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  height: 120px;
}

.overview-card {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  margin: 0 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s;
}

.overview-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.overview-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.overview-icon i {
  font-size: 30px;
  color: white;
}

.overview-content {
  flex: 1;
}

.overview-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
}

.overview-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

.overview-trend,
.overview-rate {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.trend-up {
  color: #67c23a;
}

.rate-high {
  color: #e6a23c;
  font-weight: bold;
}

/* 主体内容样式 */
.main-content {
  display: flex;
  height: calc(100% - 140px);
  gap: 20px;
}

.left-chart,
.map-container,
.right-chart {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
}

.left-chart,
.right-chart {
  width: 30%; /* 增加左侧图表宽度到30% */
  overflow-x: auto; /* 使用容器滚动条 */
  overflow-y: hidden;
}

.map-container {
  flex: 1;
  position: relative;
}

.chart-header,
.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  height: 40px;
}

.chart-header h3,
.map-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.chart-actions,
.map-actions {
  display: flex;
  align-items: center;
}

.chart-container {
  flex: 1;
  width: 100%;
}

.map-content {
  flex: 1;
}

/* 左侧图表容器样式 */
.left-chart .chart-container {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
}

/* 滚动条样式 */
.left-chart::-webkit-scrollbar {
  height: 8px;
}

.left-chart::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.left-chart::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.left-chart::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 右侧图表容器样式 */
.right-chart .chart-container {
  flex: 1;
  overflow: hidden;
}

/* 地图弹窗样式 */
.map-detail-box {
  position: absolute;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 15px;
  width: 220px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  color: #333;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  font-size: 16px;
}

.detail-header i {
  cursor: pointer;
  color: #999;
  font-size: 14px;
}

.detail-header i:hover {
  color: #333;
}

.detail-content {
  font-size: 14px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.detail-item .label {
  color: #666;
}

.detail-item .value {
  font-weight: bold;
  color: #333;
}

/* 响应式调整 */
@media (max-width: 1600px) {
  .left-chart,
  .right-chart {
    width: 30%;
  }
}

@media (max-width: 1400px) {
  .top-overview {
    flex-wrap: wrap;
    height: auto;
  }

  .overview-card {
    width: calc(50% - 20px);
    margin-bottom: 10px;
  }

  .main-content {
    flex-direction: column;
    height: auto;
  }

  .left-chart,
  .map-container,
  .right-chart {
    width: 100%;
    margin-bottom: 20px;
    height: 500px;
  }

  .left-chart {
    overflow-x: auto;
  }
}
</style>
